import React, { CSSProperties } from 'react'
import { FormattedMessage } from 'react-intl'

import { LOGIN_SITE } from '../login.enum'
import type { LoginSiteNavigator } from '../login.types'
import { Icon, IconSvg } from '../../../../components/atoms/icons'
import { Tabs } from '../../../../components/organisms/tabs'
import { breakpoints, useMediaQuery } from '../../../../lib/hooks'

const LoginSiteTab = ({
  loginSiteNavigator,
  style,
}: {
  loginSiteNavigator?: LoginSiteNavigator
  style?: CSSProperties
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)

  if (!loginSiteNavigator) {
    return null
  }

  return (
    <Tabs<LOGIN_SITE>
      tabs={[
        {
          label: isMobile ? (
            <FormattedMessage
              id='ui.loginSiteTab.label.signUpModalUserMobile'
              defaultMessage='Utilisateurs'
            />
          ) : (
            <FormattedMessage
              id='ui.loginSiteTab.label.signUpModalUser'
              defaultMessage='Espace utilisateur'
            />
          ),
          value: LOGIN_SITE.USER,
          icon: <Icon name='user-filled' size={20} />,
        },
        {
          label: isMobile ? (
            <FormattedMessage
              id='ui.loginSiteTab.label.signUpModalOwnerMobile'
              defaultMessage='Hôtes'
            />
          ) : (
            <FormattedMessage
              id='ui.loginSiteTab.label.signUpModalOwner'
              defaultMessage='Espace hôte'
            />
          ),

          value: LOGIN_SITE.OWNER,
          icon: <IconSvg.HouseLogin height={15} />,
        },
      ]}
      activeTab={loginSiteNavigator.activeSite}
      onChangeActiveTab={loginSiteNavigator.onChangeActiveSite}
      style={{ marginBottom: '20px', width: '100%', ...style }}
      forceWebStyle={true}
    ></Tabs>
  )
}

export default LoginSiteTab
